/**
 * FORGE-443 — Browser tab title management for the SPA.
 *
 * The server-rendered HTML already carries the correct <title> for each
 * physical page (magellan-bundle injects the localized order confirmation
 * title or the configured ProductDetail__c.BrowserTitle__c on the main order
 * page, and the localized "thank you" title on the confirmation / waiting
 * pages).
 *
 * This service is a defensive layer: when the SPA transitions between
 * states inside the same HTML page (e.g. confirmation -> upsell -> cross-sell),
 * we explicitly re-assert the post-purchase title so a stale value cannot
 * leak from any earlier state (back navigation, prefetch, dev tooling...).
 */

import messages from "@/i18n/messages.json";

function getLocale() {
  return window.globalConfig?.lang || "fr";
}

/**
 * Localized post-purchase title, following the domain language
 * (window.globalConfig.lang), not the visitor browser language.
 */
export const getPostPurchaseTitle = (lang = getLocale()) => {
  return (
    messages[lang]?.messages?.thanksForYourOrder ||
    messages.fr.messages.thanksForYourOrder
  );
};

/**
 * Force the browser tab title to the post-purchase value.
 * Idempotent: skips the DOM write if the title is already correct.
 */
export const setPostPurchaseTitle = () => {
  if (typeof document === "undefined") return;
  const title = getPostPurchaseTitle();
  if (document.title === title) return;
  document.title = title;
};
